import BaseComponent from '../base/BaseComponent';
import { Component, Prop, Watch } from 'vue-property-decorator';
import uuid from 'uuid/v4';
import { Mutation } from 'vuex-class';
import { SET_DOCUMENTS_ERRORS } from '@/types/documents.types';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';

@Component({})
export default class ModalComponent extends BaseComponent {

  @Mutation(SET_DOCUMENTS_ERRORS, StoreNamespace.DOCUMENT) public setDocumentsErrors;

  @Prop(Boolean) public dialogProp!: boolean;
  @Prop(Boolean) public yesNoActions!: boolean;
  @Prop(Boolean) public persistent!: boolean;
  @Prop(Boolean) public hideButtons!: boolean;
  @Prop(Boolean) public fileUploadCloseButton!: boolean;
  @Prop(String) public dialogBodyTitle!: string;
  @Prop(String) public okButtonText!: string;
  @Prop(String) public cancelButtonText!: string;
  @Prop(String) public oneButtonDialogText!: string;
  @Prop(Boolean) public closeButton!: boolean;
  @Prop(Boolean) public singleButton!: boolean;
  @Prop(Boolean) public appendFileDefaultToContentBody!: boolean;

  public modalId: string = '';
  public bodyTitle: string = '';
  public okButtonDefaultText: string = '';
  public cancelButtonDefaultText: string = '';
  public oneButtonDialogDefaultText: string = '';
  public dialog: boolean = false;

  public created() {
    this.modalId = 'modal' + uuid();
  }

  public mounted() {
    const that = this;
    document.addEventListener('keyup', (evt) => {
      if (evt.keyCode === 27) {
        that.closeDialog();
      }
    });
    this.okButtonDefaultText = this.okButtonText || this.$t('lobby.dialog.ok_button_text').toString();
    this.cancelButtonDefaultText = this.cancelButtonText || this.$t('lobby.dialog.cancel_button_text').toString();
    this.oneButtonDialogDefaultText = this.oneButtonDialogText || this.$t('lobby.dialog.got_it_button_text').toString();
    this.bodyTitle = this.dialogBodyTitle || this.$t('lobby.dialog.dialog_title').toString();
    this.dialog = this.dialogProp;
    if (this.appendFileDefaultToContentBody) {
      setTimeout(() => {
        const modalEl = document.getElementById(this.modalId);
        const bodyContent = modalEl!.querySelectorAll('.dialog-body-content')[0];
        const uploadDefault = bodyContent.querySelectorAll('.file-upload-default')[0];
        if (uploadDefault) {
          bodyContent.append(uploadDefault);
        }
      });
    }
  }

  @Watch('dialog')
  public onDialogChanged(newVal: boolean, oldVal: boolean): void {
    if (!newVal) {
      this.closeDialog();
    }
  }

  public closeDialog(): void {
    this.setDocumentsErrors([]);
    this.$emit('dialogClosed');
  }

  public closeErrorDialog(): void {
    this.$router.push({ name: 'lobby' });
    this.$emit('dialogClosed');
  }

  public confirmDialog(): void {
    this.$emit('dialogConfirm');
  }

  public dialogMaskClicked() {
    if (!this.persistent) {
      this.closeDialog();
    }
  }

}
